import {
  Alarm,
  AlarmService,
  NotificationResult,
  PostNotificationResult,
  ConfiguredAlerts,
  PostAlarm
} from '../fragments/alarm';

export const queryAlarms = `query queryAlarms(${Alarm.variable}) {${Alarm.query}}`;

export const queryAlarmsForService = `query getAlarmForService(${AlarmService.variable}) {${AlarmService.query}}`;

export const getNotificationChannels = `query getNotificationForService(${NotificationResult.variable}) {${NotificationResult.query}}`;

export const postNotificationChannels = `mutation createNotificationChannelForService(${PostNotificationResult.variable}) {${PostNotificationResult.query}}`;

export const getConfiguredAlerts = `query getAlarmForService(${ConfiguredAlerts.variable}) {${ConfiguredAlerts.query}}`;

export const postAlarm = `mutation createAlarm(${PostAlarm.variable}) {${PostAlarm.query}}`;
